import { createContext, useContext } from 'react'

export type TabsValue = string | number

export type TabsVariant = 'underline' | 'pill'

export interface TabsContextProps {
    value?: TabsValue
    onValueChange?: (value: TabsValue) => void
    variant?: TabsVariant
}

export const TabsContext = createContext<TabsContextProps>({})

export const TabsContextProvider = TabsContext.Provider

export const TabsContextConsumer = TabsContext.Consumer

export function useTabsContext() {
    return useContext(TabsContext)
} 